export default __webpack_public_path__ + "static/media/payop.94d8a68b.svg";